import { ModalRef, useEntityBaseMetadata, useEntityMetadata, useModuleFederationContext } from '@msdk/common'
import { EntityMetadata } from '@msdk/definitions'
import React, { useEffect } from 'react'

interface Props {
  entityName: string
  moduleName: string
  modalRef?: ModalRef
  children: React.ReactElement
}

export function ModalFederationWrapper(props: Props) {
  const { ensureModule, loadedModules } = useModuleFederationContext()
  const entityModel = useEntityMetadata(props.entityName)
  const baseMetadata = useEntityBaseMetadata(props.entityName) as EntityMetadata

  useEffect(() => {
    ensureModule(props.entityName, props.moduleName, baseMetadata?.msProvider, entityModel, true)
  }, [])

  const isModuleLoaded = baseMetadata ? !!loadedModules[baseMetadata.msProvider] : true
  const child = React.cloneElement(props.children, { ...props.children.props, modalRef: props.modalRef })

  return <>{isModuleLoaded && child}</>
}
